// Un identificador en la COLUMNA angosta de una lista: recortado y con el valor completo al pasar.
// En la ficha hay lugar y va con `CopyableId`, que además deja copiarlo.
import { cn } from '@/lib/cn';

/** Los últimos caracteres del ULID: es lo que distingue dos ids en una columna angosta. */
export function shortenId(value: string): string {
    return value.length <= 10 ? value : `…${value.slice(-8)}`;
}

export function IdText({ value, className }: { value: string; className?: string }) {
    return (
        <span title={value} className={cn('font-mono', className)}>
            {shortenId(value)}
        </span>
    );
}
